
































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Busy } from '@/components/Busy.ts';

import { leagueModuleName } from '@/modules/league/store/index';
import { Actions as LeagueActions } from '@/modules/league/store/actions';
import { Getters as LeagueGetters } from '@/modules/league/store/getters';
import { NextMatchWidgetState, Settings, LeagueTableState, Season, NextMatchWidgetModel } from '../store/models';
const leagueModule = namespace(leagueModuleName);

import moment from 'moment';

@Component({
  components: {
  },
})
export default class NextMatchWidget extends Vue {

  private busy: Busy = new Busy();

  @leagueModule.Getter(LeagueGetters.NEXT_MATCH_WIDGET_STATE) private nextMatchWidgetState!: NextMatchWidgetState;
  @leagueModule.Getter(LeagueGetters.NEXT_MATCH) private nextMatch!: NextMatchWidgetModel;
  @leagueModule.Action(LeagueActions.FETCH_NEXT_MATCH_WIDGET) private fetchNextMatchWidget!: (fetchMatchInput: any) => any;

  @leagueModule.Action(LeagueActions.FETCH_LEAGUE_SETTINGS) private fetchLeagueSettings!: () => any;
  @leagueModule.Getter(LeagueGetters.LOADED) private settingsLoaded!: number;
  @leagueModule.Getter(LeagueGetters.ACTIVE_SEASON) private activeSeason!: Season;

  public async mounted() {
    await this.loadData();
    this.countDown();
  }

  private async loadData() {
    await this.ensureLeagueSettingsIsLoaded().then(async () => {
      await this.ensureNextMachIsLoaded();
    });
  }

  private async ensureLeagueSettingsIsLoaded() {
    if (!this.settingsLoaded) {
      this.busy.SetBusy();
      await this.fetchLeagueSettings().then(() => {
        this.busy.SetFree();
      });
    }
  }

  private async ensureNextMachIsLoaded() {
    // if (this.nextMatchShouldBeFetched(this.nextMatchWidgetState.lastFetchedOn)) {
      if (!this.nextMatchWidgetState.isFetched) {
      this.busy.SetBusy();
      await this.fetchNextMatchWidget({ seasonId: this.activeSeason.id, teamId: this.activeSeason.teamId}).then(() => {
        this.busy.SetFree();
      });
    }
  }

  private nextMatchShouldBeFetched(lastFetchedOn?: Date) {
    // const outOfDate = moment(lastFetchedOn).add(2, 'm').toDate();
    const result = !lastFetchedOn; // || (new Date() < outOfDate);
    return result;
  }

  get isBusy() {
    return this.busy.isBusy || !this.nextMatchWidgetState.isFetched;
  }

  private countDown() {
    this.$nextTick( () => {
      const countdown: any = $('.countdown-counter');
      const countTime = countdown.data('date');
      countdown.countdown({
        date: countTime,
        render(data: any) {
          $(this.el).html(
            '<div class=\'countdown-counter__item countdown-counter__item--days\'>' +
            this.leadingZeros(data.days, 2) +
            ' <span class=\'countdown-counter__label\'>dni</span></div><div class=\'countdown-counter__item countdown-counter__item--hours\'>' +
            this.leadingZeros(data.hours, 2) +
            ' <span class=\'countdown-counter__label\'>godz</span></div><div class=\'countdown-counter__item countdown-counter__item--mins\'>' +
            this.leadingZeros(data.min, 2) +
            ' <span class=\'countdown-counter__label\'>min</span></div><div class=\'countdown-counter__item countdown-counter__item--secs\'>' +
            this.leadingZeros(data.sec, 2) +
            ' <span class=\'countdown-counter__label\'>sek</span></div>');
        },
      });
    });
  }

}
